import React from 'react';
import { NeonButton } from './ui/NeonButton';
export function FooterCTA() {
  return <footer className="py-24 bg-[#0A0A0A] border-t border-white/5 text-center relative overflow-hidden" data-id="element-96">
      {/* Background Glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[500px] h-[500px] bg-[#FF6B35] blur-[150px] opacity-10 pointer-events-none" data-id="element-97" />

      <div className="max-w-4xl mx-auto px-4 sm:px-6 relative z-10" data-id="element-98">
        <h2 className="text-5xl md:text-7xl font-black text-white mb-8 tracking-tighter uppercase italic" data-id="element-99">
          Enfocate. <br data-id="element-100" />
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#FF6B35] to-[#FF9E7D]" data-id="element-101">
            Ejecutá.
          </span>
        </h2>

        <div className="flex flex-col items-center gap-6" data-id="element-102">
          <div className="flex items-baseline gap-3" data-id="element-103">
            <span className="text-2xl text-gray-600 line-through" data-id="element-104">$57.99</span>
            <span className="text-5xl font-bold text-white" data-id="element-105">$17.99</span>
          </div>

          <p className="text-xs text-gray-500 -mt-2" data-id="element-106">
            * Precio en USD. Se mostrará en tu moneda local al hacer clic
          </p>

          <a href="https://sistemaenfocado.com" target="_blank" rel="noopener noreferrer" data-id="element-107">
            <NeonButton className="min-w-[250px] text-lg py-5" data-id="element-108">
              Obtener acceso instantáneo
            </NeonButton>
          </a>

          <p className="text-gray-500 text-sm mt-8" data-id="element-109">
            © {new Date().getFullYear()} Enfocado. Todos los derechos
            reservados.
          </p>
        </div>
      </div>
    </footer>;
}